import React, {Component} from "react";
import axios from "axios";
import {connect} from "react-redux";
import exportToExcel from "../BPContestExcelUtils";

class BPContestFileRowByVCBTO extends Component{
    constructor(props) {
        super(props);
        this.onLoading = this.props.onLoading.bind(this);
        this.onLoadMessage = this.props.onLoadMessage.bind(this);
        this.onLoadFiles = this.props.onLoadFiles.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
    }
    componentDidMount() {
    }
    render() {
        const {index,item, contestPhaseId} = this.props;
        const buttonStyle = {
            width: '200px'
        }
        return(
            <tr>
                <td>{index+1}</td>
                <td><span>{item?.title}</span></td>
                <td>
                    {item?.type === 'DETAIL' && <span>Báo cáo chi tiết</span> }
                    {item?.type === 'SUMMARY' && <span>Báo cáo tổng</span> }
                    {item?.resultFlag === '1' && <span>-Kết quả</span> }
                    {item?.resultFlag === '0' && <span>-Tạm tính</span> }
                </td>
                <td><span>{item?.createdDate}</span></td>
                <td style={buttonStyle}>
                    <button type={'button'} onClick={() =>{
                        this.onLoading(true);
                        axios.get('/api/bankportal/contest/phase/file/'+item?.id+'/report/to')
                            .then(response =>{
                                let data = [];
                                let headerArray = [];
                                if(!!response.data){
                                    data.push([response?.data?.title]);
                                    response?.data?.listHeader.map(obj =>{
                                        headerArray.push(obj);
                                    });
                                    data.push(headerArray);

                                    response?.data?.listContestExport.map(obj =>{
                                        let row = [];
                                        response?.data?.listHeader.map((header, idx) =>{
                                            if(response.data?.template === 'SUPPORT_BANKER'){
                                                if(idx === 0) row.push(obj.bankstaffCode)
                                                if(idx === 1) row.push(obj.bankstaffName)
                                                if(idx === 2) row.push(obj.toCode)
                                                if(idx === 3) row.push(obj.toName)
                                                if(idx === 4) row.push(obj.boCode)
                                                if(idx === 5) row.push(obj.boName)
                                                if(idx === 6) row.push(obj.p1)
                                                if(idx === 7) row.push(obj.p2)
                                                if(idx === 8) row.push(obj.p3)
                                                if(idx === 9) row.push(obj.p4)
                                                if(idx === 10) row.push(obj.p5)
                                                if(idx === 11) row.push(obj.p6)
                                                if(idx === 12) row.push(obj.p7)
                                                if(idx === 13) row.push(obj.p8)
                                                if(idx === 14) row.push(obj.p9)
                                                if(idx === 15) row.push(obj.p10)
                                                if(idx === 16) row.push(obj.p11)
                                                if(idx === 17) row.push(obj.p12)
                                                if(idx === 18) row.push(obj.p13)
                                                if(idx === 19) row.push(obj.p14)
                                                if(idx === 20) row.push(obj.p15)
                                                if(idx === 21) row.push(obj.p16)
                                                if(idx === 22) row.push(obj.p17)
                                                if(idx === 23) row.push(obj.p18)
                                                if(idx === 24) row.push(obj.p19)
                                                if(idx === 25) row.push(obj.p20)
                                                if(idx === 26) row.push(obj.p21)
                                                if(idx === 27) row.push(obj.p22)
                                                if(idx === 28) row.push(obj.p23)
                                                if(idx === 29) row.push(obj.p24)
                                                if(idx === 30) row.push(obj.p25)
                                                if(idx === 31) row.push(obj.p26)
                                                if(idx === 32) row.push(obj.p27)
                                                if(idx === 33) row.push(obj.p28)
                                                if(idx === 34) row.push(obj.p29)
                                                if(idx === 35) row.push(obj.p30)
                                                if(idx === 36) row.push(obj.p31)
                                                if(idx === 37) row.push(obj.p32)
                                                if(idx === 38) row.push(obj.p33)
                                                if(idx === 39) row.push(obj.p34)
                                                if(idx === 40) row.push(obj.p35)
                                                if(idx === 41) row.push(obj.p36)
                                                if(idx === 42) row.push(obj.p37)
                                                if(idx === 43) row.push(obj.p38)
                                                if(idx === 44) row.push(obj.p39)
                                                if(idx === 45) row.push(obj.p40)
                                                if(idx === 46) row.push(obj.p41)
                                                if(idx === 47) row.push(obj.p42)
                                                if(idx === 48) row.push(obj.p43)
                                                if(idx === 49) row.push(obj.p44)
                                                if(idx === 50) row.push(obj.p45)
                                                if(idx === 51) row.push(obj.p46)
                                                if(idx === 52) row.push(obj.p47)
                                                if(idx === 53) row.push(obj.p48)
                                                if(idx === 54) row.push(obj.p49)
                                                if(idx === 55) row.push(obj.p50)
                                            }else {
                                                if (idx === 0) row.push(obj.toCode)
                                                if (idx === 1) row.push(obj.toName)
                                                if (idx === 2) row.push(obj.boCode)
                                                if (idx === 3) row.push(obj.boName)
                                                if (idx === 4) row.push(obj.p1)
                                                if (idx === 5) row.push(obj.p2)
                                                if (idx === 6) row.push(obj.p3)
                                                if (idx === 7) row.push(obj.p4)
                                                if (idx === 8) row.push(obj.p5)
                                                if (idx === 9) row.push(obj.p6)
                                                if (idx === 10) row.push(obj.p7)
                                                if (idx === 11) row.push(obj.p8)
                                                if (idx === 12) row.push(obj.p9)
                                                if (idx === 13) row.push(obj.p10)
                                                if (idx === 14) row.push(obj.p11)
                                                if (idx === 15) row.push(obj.p12)
                                                if (idx === 16) row.push(obj.p13)
                                                if (idx === 17) row.push(obj.p14)
                                                if (idx === 18) row.push(obj.p15)
                                                if (idx === 19) row.push(obj.p16)
                                                if (idx === 20) row.push(obj.p17)
                                                if (idx === 21) row.push(obj.p18)
                                                if (idx === 22) row.push(obj.p19)
                                                if (idx === 23) row.push(obj.p20)
                                                if (idx === 24) row.push(obj.p21)
                                                if (idx === 25) row.push(obj.p22)
                                                if (idx === 26) row.push(obj.p23)
                                                if (idx === 27) row.push(obj.p24)
                                                if (idx === 28) row.push(obj.p25)
                                                if (idx === 29) row.push(obj.p26)
                                                if (idx === 30) row.push(obj.p27)
                                                if (idx === 31) row.push(obj.p28)
                                                if (idx === 32) row.push(obj.p29)
                                                if (idx === 33) row.push(obj.p30)
                                                if (idx === 34) row.push(obj.p31)
                                                if (idx === 35) row.push(obj.p32)
                                                if (idx === 36) row.push(obj.p33)
                                                if (idx === 37) row.push(obj.p34)
                                                if (idx === 38) row.push(obj.p35)
                                                if (idx === 39) row.push(obj.p36)
                                                if (idx === 40) row.push(obj.p37)
                                                if (idx === 41) row.push(obj.p38)
                                                if (idx === 42) row.push(obj.p39)
                                                if (idx === 43) row.push(obj.p40)
                                                if (idx === 44) row.push(obj.p41)
                                                if (idx === 45) row.push(obj.p42)
                                                if (idx === 46) row.push(obj.p43)
                                                if (idx === 47) row.push(obj.p44)
                                                if (idx === 48) row.push(obj.p45)
                                                if (idx === 49) row.push(obj.p46)
                                                if (idx === 50) row.push(obj.p47)
                                                if (idx === 51) row.push(obj.p48)
                                                if (idx === 52) row.push(obj.p49)
                                                if (idx === 53) row.push(obj.p50)
                                            }
                                        });
                                        data.push(row);
                                    });
                                    this.exportToExcel(data, response?.data?.reportName);
                                    this.onLoadMessage('Tải báo cáo thành công');
                                    this.onLoading(false);
                                }else{
                                    this.onLoadMessage('Không tìm thấy dữ liệu phù hợp!');
                                    this.onLoading(false);
                                }
                            })
                            .catch(error =>{
                                console.error('There was an error!', error);
                                this.onLoadMessage(error.message);
                                this.onLoading(false);
                            });
                    }} className={'btn btn-info btn-sm d-inline'} >Xem chi tiết</button>
                </td>
            </tr>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(BPContestFileRowByVCBTO)